import { Injectable } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RestActivityHandlerService {

  readonly onRequestCountChange: BehaviorSubject<boolean>;

  private requestCount: number = 0;

  constructor() {
    this.onRequestCountChange = new BehaviorSubject<boolean>(false);
  }

  getRequestCount(): number {
    return this.requestCount;
  }

  hasActiveRequests(): boolean {
    return this.onRequestCountChange.getValue();
  }

  start(): void {
    if (this.requestCount === 0) {
      Promise.resolve().then((): void => this.onRequestCountChange.next(true));
    }
    this.requestCount++;
  }

  complete(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }
    if (this.requestCount === 0) {
      Promise.resolve().then((): void => this.onRequestCountChange.next(false));
    }
  }

}
